import ReducerAction from '../../../../types/action';
import Action from './action';
import State from './state';

export default function reducer(state: State, action: ReducerAction): State {
  if (action.type === Action.AddFile) {
    return {
      ...state,
      files: [...state.files, action.payload],
    };
  }

  if (action.type === Action.UpdateFile) {
    return {
      ...state,
      files: state.files.map((file) =>
        file.id === action.payload.id ? { ...file, ...action.payload } : file
      ),
    };
  }

  if (action.type === Action.RemoveFile) {
    return {
      ...state,
      files: state.files.filter((file) => file.id !== action.payload.id),
    };
  }

  return state;
}
